import script from "./OvertimeOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./OvertimeOverview.vue?vue&type=script&setup=true&lang=ts"

import "./OvertimeOverview.vue?vue&type=style&index=0&id=4d4975b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d4975b2"]])

export default __exports__